<template>
  <section class="container page-py" dir="ltr">
    <div
      class="bread-crumbs"
      itemscope
      itemtype="http://schema.org/BreadcrumbList"
    >
      <div
        class="navigate-info"
        itemprop="itemListElement"
        itemscope
        itemtype="http://schema.org/ListItem"
      >
        <nuxt-link
          to="/blog"
          class="navigate-info-route"
          itemprop="item"
        >
          <meta itemprop="position" content="1" />
          {{ $t('Blog') }} </nuxt-link
        ><span class="navigate-info__arrow">></span
        ><span class="navigate-info__span" itemprop="name">{{
          $t('artTitle31')
        }}</span
        ><meta itemprop="position" content="2" />
      </div>
    </div>
    <h1>{{ $t('artTitle31') }}</h1>
    <p>{{ $t('artText31-1') }}</p>
    <img
      :src="`${staticUrl}/images/blog/Enhancing_Your_Apartment_with_Contemporary_Design_Solutions_for_Windows_PC.webp`"
      :alt="'altImageDefault'"
    />
    <p>{{ $t('artText31-2') }}</p>
    <p>{{ $t('artText31-3') }}</p>
    <p>{{ $t('artText31-4') }}</p>
    <p>{{ $t('artText31-5') }}</p>
    <p>{{ $t('artText31-6') }}</p>
    <p>{{ $t('artText31-7') }}</p>
    <p>{{ $t('artText31-8') }}</p>
    <p>{{ $t('artText31-9') }}</p>
    <p>{{ $t('artText31-10') }}</p>
    <p>{{ $t('artText31-11') }}</p>
    <p>{{ $t('artText31-12') }}</p>
    <p>{{ $t('artText31-13') }}</p>
    <p>{{ $t('artText31-14') }}</p>
    <p>{{ $t('artText31-15') }}</p>
    <p>{{ $t('artText31-16') }}</p>
    <p>{{ $t('artText31-17') }}</p>
    <p>{{ $t('artText31-18') }}</p>
    <p>{{ $t('artText31-19') }}</p>
    <p>{{ $t('artText31-20') }}</p>
    <p>{{ $t('artText31-21') }}</p>
    <img
      :src="`${staticUrl}/images/blog/Enhancing_Your_Apartment_with_Contemporary_Design_Solutions_for_Windows_PC_1.webp`"
      :alt="'altImageDefault'"
    />
    <p>{{ $t('artText31-22') }}</p>
  </section>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const {t} = useI18n();

useSeoMeta({
  title: `${t('artSeoTitle31')}`,
  ogTitle: `${t('artSeoTitle31')}`,
  description: `${t('artSeoDesc31')}`,
  ogDescription: `${t('artSeoDesc31')}`,
  ogImage: 'https://dreamflat.design/prev.webp',
  twitterCard: 'summary_large_image',
});
</script>

<style scoped lang="scss">
@import 'css/blog/blog';
</style>
